module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "footer"
    }
  }, [_c('div', {
    attrs: {
      "id": "content_footer"
    }
  }, [_c('div', {
    attrs: {
      "id": "copyright"
    }
  }, [_vm._v("© 2009-" + _vm._s(_vm.year) + " StumptheSpread.com")]), _vm._v(" "), (!_vm.isLogin) ? _c('div', {
    attrs: {
      "id": "back_to_top"
    }
  }, [_vm._m(0)]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "sprite back_to_top",
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "title": "Back to the Top"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13a24f01"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/StsFooter.vue
// module id = 274
// module chunks = 1